<template>
    <Layout>
      <div v-if="nSubs" class="row">
        <b-modal
      v-model="showModal"
      title="Add Inventory"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
    >
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="name">Name</label>
              <input
                id="name"
                v-model="selectedInventory.name"
                type="text"
                class="form-control"
                placeholder="Insert name"
                :class="{ 'is-invalid': submitted && v$.event.title.$error }"
              />
              <div
                v-if="submitted && v$.event.title.$error"
                class="invalid-feedback"
              >
                <span v-if="v$.event.title.required.$message">{{
                  v$.event.title.required.$message
                }}</span>
              </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <img v-if="selectedInventory.img" :src="selectedInventory.img"
                        alt=""
                        class="img-thumbnail d-block"
                      />
                </div>
                <div class="col-6">
                    <div class="mt-3">
                    <label for="formFile" class="form-label"
                      >Image</label
                    >
                    <input accept="image/x-png,image/jpg,image/jpeg" :required="!selectedInventory.img" @change="onFileChanged" class="form-control" type="file" id="formFile" />
                  </div>
                </div>
            </div>
            <div class="mb-3">
                            <label for="commentmessage-input">Description</label>
                            <textarea
                              class="form-control"
                              id="commentmessage-input"
                              placeholder="Your Desc"
                              rows="3"
                              v-model="selectedInventory.desc"
                            ></textarea>
                          </div>
                          <div class="mb-3">
              <label for="name">Selling Price</label>
              <input
                id="buyPrice"
                v-model="selectedInventory.buyPrice"
                type="number"
                class="form-control"
                placeholder="Insert Price E.C"
              />
            </div>
                          <div class="mb-3">{{errorMsg}}</div>
          </div>
        </div>

        <div class="text-end pt-5 mt-3">
          <b-button variant="light" @click="hideModal">Close</b-button>
          <b-button type="submit" variant="success" class="ms-1"
            >{{selectedInventory.id ? 'Update':'Add Item'}}</b-button
          >
        </div>
      </form>
    </b-modal>
      <div class="col-12">
        <div class="row">
                <div class="col-lg-12 text-end" style="padding-bottom:10px;">
                    <a href="javascript: void(0);" @click="showModel" class="btn btn-primary btn-sm">Add Inventory</a>
                </div>
            </div>
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Inventory</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="nSubs"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
              <template #cell(img)="data">
                <div class="me-3">
                <img
                  class="media-object rounded-circle avatar-xs"
                  alt
                  :src="data.value"
                />
              </div>
              </template>
              <template #cell(id)="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <button
                tag="button"
                @click="showModel(data)"
                class="btn btn-primary btn-rounded"
              >
                EDIT
            </button>
        <!-- <a :href="`#${data.value.replace(/[^a-z]+/i,'-').toLowerCase()}`">{{ data.value }}</a> -->
      </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center">Nothing to show</div>  
    </Layout>
  
</template>

<script>
    import appConfig from "@/app.config";
    import Layout from "../../layouts/main";
    import { required, helpers } from "@vuelidate/validators";
    import useVuelidate from "@vuelidate/core";
    import firebase from 'firebase/app';
    import 'firebase/storage'; 

export default {
    setup() {
    return { v$: useVuelidate() };
  },
    page: {
    title: "Inventory",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data(){
    return {
        errorMsg: "",
        tempImg: "",
        uploadValue: "",
        selectedInventory: {
            name: "",
            desc: "",
            img: "",
            isAvailable: true,
            buyPrice: 0
        },
        showModal: false,
        perPage: 10,
      totalRows: 1,
        filter: null,
      filterOn: [],
        nSubs: [],
        sortBy: "",
      sortDesc: false,
      pageOptions: [10, 25, 50, 100],
      currentPage: 1,
      submitted: false,
        fields: [
        {
          key: "img",
          sortable: false,
        },
        {
          key: "name",
          sortable: true,
        },
        {
          key: "desc",
          sortable: false,
        },
        {
          key: "buyPrice",
          sortable: false
        },
        {
            key: "id",
            sortable: false
        }
      ],
    }
  },
  validations: {
    event: {
      title: {
        required: helpers.withMessage("Title is required", required),
      },
      category: {
        required: helpers.withMessage("Category is required", required),
      },
    },
  },
  methods: {
    resetStuff(){
      this.selectedInventory = {
            name: "",
            desc: "",
            img: "",
            isAvailable: true,
            buyPrice: 0
        }
    },
    async getInventory(){
        this.nSubs = []
        await firebase.firestore().collection("curi_hardware")
        .get().then((hData)=>{
            if(hData.size > 0){
                hData.docs.forEach((item)=>{
                    var data = item.data()
                    data.id = item.id
                    data.action = "nothing"
                    this.nSubs.push(data)
                })
            }
        })
    },
    onFileChanged(event) {
      const file = event.target.files[0]
      this.tempImg = file
    },
    async startSendingData(){
      if(this.selectedInventory.id){
        await firebase.firestore().collection("curi_hardware").doc(this.selectedInventory.id)
        .update(this.selectedInventory);
      }else{
        await firebase.firestore().collection("curi_hardware").add(this.selectedInventory);
      }
      this.hideModal()
        this.getInventory()
    },
    async onUpload(dataObject) {
      if (dataObject.imageFile) {
        //limits:
        var maxSize = 2096
        var limitTxt= "2mb"
        //--
        const fsize = dataObject.imageFile.size
        const file = Math.round(fsize / 1024)
        this.uploadValue = ""
        if (file >= maxSize && dataObject.folderName != null) {
          alert("File too Big, please select a file less than "+limitTxt)
        } else {
          const str = dataObject.imageFile.name.replace(/\s+/g, "")
          const storageRef = firebase.storage()
            .ref(`${dataObject.folderName}` + "/" + `${str}`)
            .put(dataObject.imageFile)
          storageRef.on(
            `state_changed`,
            (snapshot) => {
              this.uploadValue =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            },
            (error) => {
                // eslint-disable-next-line no-console
              console.log(error.message)
              this.uploadValue = "error with last upload " + error.message
            },
            () => {
              this.uploadValue = ""

              storageRef.snapshot.ref.getDownloadURL().then((url) => {
                this.selectedInventory.img = url
                this.startSendingData()
              })
            }
          )
        }
      }else{
        this.startSendingData()
      }
    },
    preparUpload(folderName) {
      var dataObject = {
        folderName: folderName,
        imageFile: this.tempImg,
      }
      this.onUpload(dataObject)
      this.tempImg = ""
    },
    handleSubmit(){
        // this.v$.$touch();
        // eslint-disable-next-line no-console
        // console.log(e)
        if(this.selectedInventory.name == ""){
            this.errorMsg = "enter inv name"
            return;
        }
        if(this.selectedInventory.id){
          // eslint-disable-next-line no-console
          console.log("editing")
        }else{
          if(this.tempImg == ""){
            this.errorMsg = "upload image"
            return;
        }
        }
        
        if(this.selectedInventory.desc == ""){
            this.errorMsg = "enter desc"
            return;
        }
        if(this.selectedInventory.buyPrice == ""|| this.selectedInventory.buyPrice == "0" || this.selectedInventory.buyPrice == undefined){
          this.errorMsg = "enter price"
          return;
        }
        this.preparUpload("inventory")
        
    },
    hideModal(){
        this.showModal = false;
        this.resetStuff()
    },
    showModel(data){
        this.resetStuff()
        this.tempImg = ""
        if(data.value){
           this.selectedInventory = this.nSubs.find(element => element.id == data.value) 
        }
        
        this.showModal = true;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  mounted() {
    this.getInventory();
  },
  computed: {
      rows() {
      return this.nSubs.length;
    },
  },
}
</script>

<style>

</style>